import * as React from "react"
const ViewIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={10}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#4A4A4A"
        d="M11.34 3.772C10.563 2.447 8.831.219 5.915.219c-2.91 0-4.648 2.228-5.418 3.553a2.153 2.153 0 0 0 0 2.172c.77 1.33 2.508 3.559 5.418 3.559 2.916 0 4.648-2.228 5.423-3.559.191-.327.293-.701.295-1.083a2.209 2.209 0 0 0-.295-1.09ZM5.915 7.646a2.65 2.65 0 0 1-1.503-.47 2.77 2.77 0 0 1-.997-1.25 2.861 2.861 0 0 1-.154-1.608c.104-.54.362-1.037.74-1.427.379-.39.861-.654 1.386-.762a2.634 2.634 0 0 1 1.563.159c.495.21.917.567 1.215 1.025a2.844 2.844 0 0 1-.338 3.516 2.671 2.671 0 0 1-1.912.817Zm1.497-2.872a.418.418 0 0 1 .006.087c0 .352-.116.694-.33.97a1.499 1.499 0 0 1-.847.542 1.465 1.465 0 0 1-.99-.12 1.528 1.528 0 0 1-.7-.734 1.59 1.59 0 0 1-.1-1.021c.081-.343.273-.647.544-.862a1.476 1.476 0 0 1 1.882.037.616.616 0 0 0-.262.23.63.63 0 0 0 .077.776.595.595 0 0 0 .425.182c.105 0 .207-.03.295-.087Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h12v10H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default ViewIcon
